module.exports = __webpack_public_path__ + "static/media/expandIcon.svg";